import React, { useState } from "react";
import "../styles/Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faUser, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import Img from "../assets/location.jpeg";
import { db } from "../firebase.js";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import SEO from "../components/SEO.js";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "contact"), {
        name: formData.name,
        contact: formData.contact,
        message: formData.message,
        createdAt: serverTimestamp(),
      });

      alert("Thank you for contacting us! We'll get back to you soon.");
      setFormData({ name: "", contact: "", message: "" });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Something went wrong! Please try again.");
    }
  };

  return (
    <section id="contact">
  
  <SEO
  title="Best Imported Marble Showroom in Kishangarh, India - Contact Square Feet Marble"
  description="Visit our imported marble showroom in Kishangarh or contact the top marble supplier in India for premium Italian and imported marble."
  keywords="imported marble supplier Kishangarh, marble showroom Kishangarh, top imported marble dealer India"
  canonical="https://squarefeetmarble.com/contact"
  ogImage="https://squarefeetmarble.com/imported-marble-kishangarh-stockyard-1.webp"
/>
      <div className="contact-container">
        {/* Left Side - Form */}
        <div className="contact-form">
          <h2>Send a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <FontAwesomeIcon icon={faUser} className="input-icon" />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="contact"
                placeholder="Contact Number"
                value={formData.contact}
                onChange={handleChange}
                required
              />
              <FontAwesomeIcon icon={faPhone} className="input-icon" />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <FontAwesomeIcon icon={faPaperPlane} className="input-icon textarea-icon" />
            </div>

            <button type="submit" className="submit-btn">
              <FontAwesomeIcon icon={faPaperPlane} /> Send Message
            </button>
          </form>
        </div>

        {/* Right Side - Image */}
        <div className="contact-image">
          <img src={Img} alt="Img" />
        </div>
      </div>
    </section>
  );
};

export default Contact;
